import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './GradeHeader.scss';
import Button from 'Components/Button';
import RampUnit from '../../utils/Playwire/RampUnit';
import Hero from 'Containers/Hero';
import GradeHeaderNumber from './grade-header-number.svg';
import MathZoneHeader from './math-zone-header.svg';

class GradeHeader extends Component {
  render() {
    const { zone, hero } = this.props;
    return (
      <div className="GradeHeader">
        <div className="GradeHeader__content">
          <div className="GradeHeader__grade">
            {zone === 'math' ? (
              <MathZoneHeader className="GradeHeader__grade-svg" />
            ) : (
              <GradeHeaderNumber className="GradeHeader__grade-svg" />
            )}
          </div>
          <Hero hero={hero} heroType="grade" className="GradeHeader__hero" />
        </div>
        <div className="GradeHeader__aside">
          <RampUnit type="med_rect_atf" id="siderec" />
        </div>
      </div>
    );
  }
}

export default GradeHeader;
